import { Modal, Button } from "react-bootstrap";
import "./ConfirmModal.css";

export default function ConfirmModal({
  show,
  onConfirm,
  onCancel,
  sending = false,
  title = "Oddaja prijave",
  message = "Oddali boste prijavo na konferenco. Ali želite nadaljevati?",
}) {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered
      backdrop="static"
      contentClassName="confirm-modal-content"
    >
      <Modal.Header closeButton={!sending}>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button
          variant=""
          className="confirm-modal-btn-cancel"
          onClick={onCancel}
          disabled={sending}
        >
          Prekliči
        </Button>
        <Button
          variant=""
          className="confirm-modal-btn-confirm"
          onClick={onConfirm}
          disabled={sending}
        >
          {sending ? "Pošiljam..." : "Potrdi in pošlji"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
